import * as React from 'react';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { TransRowView } from 'gossamer-model';

export const TransRowSearch: React.FC = () => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(TransRowView);
  const gCacheQueryItem = useCacheQuery(TransRowView, queryOptions);
  return (
    <>
      <PageTitle verb="Search" entity={TransRowView} />
      <Section>
        <PaginatorAndListSettings
          entity={TransRowView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
